import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, ChevronDown, Phone } from "lucide-react";

const SERVICES = [
  { slug: "laparoscopic-hernia-surgery-vijayawada", title: "Laparoscopic Hernia Surgery" },
  { slug: "laparoscopic-gallbladder-surgery-vijayawada", title: "Laparoscopic Gallbladder Surgery" },
  { slug: "laparoscopic-appendicectomy-vijayawada", title: "Laparoscopic Appendicectomy" },
  { slug: "laser-piles-treatment-vijayawada", title: "Laser Piles Treatment" },
  { slug: "laser-fissure-treatment-vijayawada", title: "Laser Fissure Treatment" },
  { slug: "laser-fistula-treatment-vijayawada", title: "Laser Fistula Treatment" },
  { slug: "thyroid-surgery-vijayawada", title: "Thyroid Surgery" },
  { slug: "varicose-veins-treatment-vijayawada", title: "Varicose Veins Treatment" },
  { slug: "breast-disease-treatment-vijayawada", title: "Breast Disease Treatment" },
  { slug: "circumcision-vijayawada", title: "Circumcision" },
  { slug: "swellings-lipoma-abscess-cyst-vijayawada", title: "Swellings — Lipoma / Abscess / Cyst" },
  { slug: "cellulitis-treatment-vijayawada", title: "Cellulitis" },
  { slug: "ulcer-treatment-vijayawada", title: "Ulcers" },
  { slug: "endoscopy-vijayawada", title: "Endoscopy" },
  { slug: "colonoscopy-vijayawada", title: "Colonoscopy" },
  { slug: "intestinal-surgeries-vijayawada", title: "Intestinal Surgeries" },
];

export default function Header({ onBookAppointment }) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    function handleScroll() { setIsScrolled(window.scrollY > 20); }
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
    setIsServicesOpen(false);
  }, [location]);

  function scrollToSection(id) {
    if (location.pathname !== "/") { window.location.href = "/#" + id; return; }
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    setIsMobileMenuOpen(false);
  }

  const navLinks = [
    { label: "Home", action: () => scrollToSection("hero") },
    { label: "About", action: () => scrollToSection("about") },
    { label: "Services", dropdown: true },
    { label: "Health Blogs", to: "/blogs" },
    { label: "Locations", action: () => scrollToSection("locations") },
    { label: "Testimonials", action: () => scrollToSection("testimonials") },
    { label: "FAQ", action: () => scrollToSection("faq") },
    { label: "Contact", action: () => scrollToSection("locations") },
  ];

  const headerStyle = isScrolled ? {
    background: "rgba(255,255,255,0.88)",
    backdropFilter: "blur(20px)",
    WebkitBackdropFilter: "blur(20px)",
    borderBottom: "1px solid rgba(46,111,184,0.12)",
    boxShadow: "0 4px 24px rgba(31,78,121,0.10)"
  } : {
    background: "rgba(255,255,255,0.95)",
    backdropFilter: "blur(16px)",
    WebkitBackdropFilter: "blur(16px)",
    borderBottom: "1px solid rgba(46,111,184,0.10)"
  };

  return (
    <header className="fixed left-0 right-0 z-[55] transition-all duration-300 header-top" style={{ ...headerStyle }}>
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl">
        <div className="flex items-center justify-between h-24 md:h-28">

          <Link to="/" className="flex items-center">
            <img
              src="/images/logo.webp"
              alt="Dr. Dileep Sunkavalli"
              className="h-20 md:h-24 w-auto object-contain"
            />
          </Link>

          <nav className="hidden lg:flex items-center gap-0.5">
            {navLinks.map((link) => {
              if (link.dropdown) {
                return (
                  <div
                    key={link.label}
                    className="relative"
                    onMouseEnter={() => setIsServicesOpen(true)}
                    onMouseLeave={() => setIsServicesOpen(false)}
                  >
                    <button
                      className="flex items-center gap-1 text-sm font-medium px-3 py-2 rounded-lg transition-all"
                      style={{ color: "#1F4E79" }}
                      onMouseEnter={e => e.currentTarget.style.background = "rgba(46,111,184,0.08)"}
                      onMouseLeave={e => e.currentTarget.style.background = "transparent"}
                    >
                      {link.label}
                      <ChevronDown className={"w-3.5 h-3.5 transition-transform " + (isServicesOpen ? "rotate-180" : "")} />
                    </button>
                    {isServicesOpen && (
                      <div style={{
                        position: "absolute", top: "100%", left: 0, width: 300,
                        background: "rgba(255,255,255,0.92)",
                        backdropFilter: "blur(20px)",
                        WebkitBackdropFilter: "blur(20px)",
                        borderRadius: 14,
                        border: "1px solid rgba(46,111,184,0.14)",
                        boxShadow: "0 16px 48px rgba(31,78,121,0.14), inset 0 1px 0 rgba(255,255,255,0.9)",
                        padding: "8px 0",
                        maxHeight: "70vh",
                        overflowY: "auto"
                      }}>
                        {SERVICES.map((s) => (
                          <Link
                            key={s.slug}
                            to={"/services/" + s.slug}
                            className="block px-4 py-2 text-sm transition-colors"
                            style={{ color: "#0F2A3D" }}
                            onMouseEnter={e => { e.currentTarget.style.background = "rgba(46,111,184,0.07)"; e.currentTarget.style.color = "#1F4E79"; }}
                            onMouseLeave={e => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = "#0F2A3D"; }}
                          >
                            {s.title}
                          </Link>
                        ))}
                      </div>
                    )}
                  </div>
                );
              }
              if (link.to) {
                return (
                  <Link
                    key={link.label}
                    to={link.to}
                    className="text-sm font-medium px-3 py-2 rounded-lg transition-all"
                    style={{ color: "#1F4E79" }}
                    onMouseEnter={e => e.currentTarget.style.background = "rgba(46,111,184,0.08)"}
                    onMouseLeave={e => e.currentTarget.style.background = "transparent"}
                  >
                    {link.label}
                  </Link>
                );
              }
              return (
                <button
                  key={link.label}
                  onClick={link.action}
                  className="text-sm font-medium px-3 py-2 rounded-lg transition-all"
                  style={{ color: "#1F4E79" }}
                  onMouseEnter={e => e.currentTarget.style.background = "rgba(46,111,184,0.08)"}
                  onMouseLeave={e => e.currentTarget.style.background = "transparent"}
                >
                  {link.label}
                </button>
              );
            })}
          </nav>

          <div className="hidden lg:flex items-center gap-3">
            {/* Call Now — glass */}
            <a
              href="tel:+917075659696"
              className="flex items-center gap-2 text-sm font-medium px-4 py-2.5 rounded-xl transition-all"
              style={{
                color: "#1F4E79",
                background: "rgba(46,111,184,0.07)",
                border: "1px solid rgba(46,111,184,0.15)"
              }}
              onMouseEnter={e => e.currentTarget.style.background = "rgba(46,111,184,0.13)"}
              onMouseLeave={e => e.currentTarget.style.background = "rgba(46,111,184,0.07)"}
            >
              <Phone className="w-4 h-4" strokeWidth={1.5} />
              Call Now
            </a>
            {/* Book Appointment — solid */}
            <button
              onClick={onBookAppointment}
              className="text-white font-semibold px-6 py-2.5 rounded-xl text-sm transition-all hover:-translate-y-0.5"
              style={{
                background: "linear-gradient(135deg, #2E6FB8 0%, #1F4E79 100%)",
                boxShadow: "0 4px 16px rgba(31,78,121,0.28), inset 0 1px 0 rgba(255,255,255,0.15)"
              }}
              onMouseEnter={e => e.currentTarget.style.boxShadow = "0 8px 24px rgba(31,78,121,0.36), inset 0 1px 0 rgba(255,255,255,0.15)"}
              onMouseLeave={e => e.currentTarget.style.boxShadow = "0 4px 16px rgba(31,78,121,0.28), inset 0 1px 0 rgba(255,255,255,0.15)"}
            >
              Book Appointment
            </button>
          </div>

          <div className="lg:hidden flex items-center gap-2">
            <button
              onClick={onBookAppointment}
              className="text-white font-semibold px-4 py-2 rounded-xl text-xs"
              style={{
                background: "linear-gradient(135deg, #2E6FB8 0%, #1F4E79 100%)",
                boxShadow: "0 4px 12px rgba(31,78,121,0.28)"
              }}
            >
              Book Appointment
            </button>
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="p-2 rounded-lg"
              style={{ color: "#1F4E79" }}
            >
              {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {isMobileMenuOpen && (
        <div style={{
          background: "rgba(255,255,255,0.95)",
          backdropFilter: "blur(20px)",
          WebkitBackdropFilter: "blur(20px)",
          borderTop: "1px solid rgba(46,111,184,0.10)",
          boxShadow: "0 16px 40px rgba(31,78,121,0.12)"
        }}>
          <div className="container mx-auto px-4 py-4 space-y-1">
            {navLinks.map((link) => {
              if (link.dropdown) {
                return (
                  <div key={link.label}>
                    <button
                      onClick={() => setIsServicesOpen(!isServicesOpen)}
                      className="flex items-center justify-between w-full text-left text-base font-medium py-2.5 px-3 rounded-lg transition-all"
                      style={{ color: "#1F4E79" }}
                    >
                      {link.label}
                      <ChevronDown className={"w-4 h-4 transition-transform " + (isServicesOpen ? "rotate-180" : "")} />
                    </button>
                    {isServicesOpen && (
                      <div className="pl-4 space-y-0.5 max-h-48 overflow-y-auto">
                        {SERVICES.map((s) => (
                          <Link
                            key={s.slug}
                            to={"/services/" + s.slug}
                            className="block text-sm py-1.5 px-3 rounded-lg transition-all"
                            style={{ color: "#5A6E7F" }}
                            onClick={() => setIsMobileMenuOpen(false)}
                          >
                            {s.title}
                          </Link>
                        ))}
                      </div>
                    )}
                  </div>
                );
              }
              if (link.to) {
                return (
                  <Link
                    key={link.label}
                    to={link.to}
                    onClick={() => setIsMobileMenuOpen(false)}
                    className="block text-base font-medium py-2.5 px-3 rounded-lg"
                    style={{ color: "#1F4E79" }}
                  >
                    {link.label}
                  </Link>
                );
              }
              return (
                <button
                  key={link.label}
                  onClick={link.action}
                  className="block w-full text-left text-base font-medium py-2.5 px-3 rounded-lg"
                  style={{ color: "#1F4E79" }}
                >
                  {link.label}
                </button>
              );
            })}
            <div className="pt-3" style={{ borderTop: "1px solid rgba(46,111,184,0.1)" }}>
              <button
                onClick={() => { onBookAppointment(); setIsMobileMenuOpen(false); }}
                className="w-full text-white font-semibold py-3 rounded-xl text-center"
                style={{ background: "linear-gradient(135deg, #2E6FB8 0%, #1F4E79 100%)" }}
              >
                Book Appointment
              </button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
